import React, { useState } from "react";
import DaonLogo from "../../assets/daon-logo_0.jpg";
import PageContent from "../PageContent";
import ButtonRestartApp from "../ButtonRestartApp";
import { Modal } from "react-bootstrap";
import { PrivacyPolicy } from "./privacyPolicy";
import { TermsOfUse } from "./termsOfUse";
import "./style.css";

import { next } from "../../logic/actions/navigation";
import { useDispatch } from "react-redux";
import { sendConsent } from "../../logic/actions/api/gdpr";
import { logEvent, STEP_COMPLETED } from "../../logic/eventLogger";

export default function PageGDPR() {
  const dispatch = useDispatch();
  const [checked, setChecked] = useState(false);
  const [showTermsOfUse, setShowTermsOfUse] = useState(false);
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [isInProgress, setIsInProgress] = useState(false);

  function toggleCheckBox(e) {
    setChecked(e.target.checked);
  }

  function nextPage() {
    if (checked) {
      next()(dispatch);
    }
  }

  function acceptGDPR() {
    if (!isInProgress) {
      setIsInProgress(true);
      sendConsent()(dispatch)
        .then((response) => {
          if (response.ok) {
            logEvent(STEP_COMPLETED, { value: "gdpr" });
            logEvent(STEP_COMPLETED + "_gdpr");
            nextPage();
          } else {
            setHasError(true);
            setIsInProgress(false);
          }
        })
        .catch(() => {
          setHasError(true);
          setIsInProgress(false);
        });
    }
  }

  function toggleTermsOfUse() {
    setShowTermsOfUse(!showTermsOfUse);
  }

  function togglePrivacyPolicy() {
    setShowPrivacyPolicy(!showPrivacyPolicy);
  }

  const textStyle = {
    color: "blue",
    cursor: "pointer",
  };

  return (
    <PageContent showVersion={true} progressBar={true} progressPercentage={10}>
      <header className="header">
        <img
          alt="daon_image"
          align="center"
          className="daon-image"
          src={DaonLogo}
        />
      </header>
      <div className="panel border-green">
        <div className="column">
          <div className="row row-justify-center">
            <p>Terms of Use</p>
            <h6>
              <p
                style={textStyle}
                onClick={toggleTermsOfUse}
                data-toggle="modal"
              >
                View our terms of use.
              </p>
            </h6>
          </div>
          <hr />
          <div className="row row-justify-center">
            <p>Privacy Policy</p>
            <h6>
              <p
                style={textStyle}
                onClick={togglePrivacyPolicy}
                data-toggle="modal"
              >
                View our privacy policy.
              </p>
            </h6>
          </div>
          <hr />
          <div className="row row-justify-center">
            <p style={{ marginLeft: 30 }}>
              I explicitly consent to the processing of my biometrics for the
              purpose of authentication by this application.
            </p>
            <input
              type="checkbox"
              checked={checked}
              onChange={toggleCheckBox}
              className="checkbox"
            />
          </div>
          <hr />
        </div>
      </div>
      <Modal show={showTermsOfUse} onHide={toggleTermsOfUse}>
        <Modal.Header closeButton>
          <Modal.Title>
            <p>
              <strong>TERMS OF USE</strong>
            </p>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <TermsOfUse />
        </Modal.Body>

        <Modal.Footer></Modal.Footer>
      </Modal>
      <Modal show={showPrivacyPolicy} onHide={togglePrivacyPolicy}>
        <Modal.Header closeButton>
          <Modal.Title>
            <p>
              <strong>Privacy Policy</strong>
            </p>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <PrivacyPolicy />
        </Modal.Body>

        <Modal.Footer></Modal.Footer>
      </Modal>
      <div className="row row-justify-center">
        <button
          onClick={acceptGDPR}
          disabled={!checked || isInProgress}
          id="agreeButton"
          type="button"
          className={checked ? "btn blue" : "btn gray"}
        >
          I agree
        </button>
      </div>

      {hasError && (
        <>
          <p className="error">
            An error occured, please try again later or contact our support
          </p>
          <ButtonRestartApp />
        </>
      )}
    </PageContent>
  );
}
